// export const API_URL_AUTH_PROD = 'http://localhost:8080/api/v1/auth/';
// export const API_URL_PROD = 'http://localhost:8080/';
export const API_URL_PROD = 'https://smarterbackenddeploy.onrender.com/';
export const API_URL_AUTH_PROD =
  'https://smarterbackenddeploy.onrender.com/api/v1/auth/';
